import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { colorIconSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1u4j134";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const closeButtonCss = "cwuu7h6";
const CloseButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
export const Controls = ({
  onRemove
}) => <Container>
    <CloseButton aria-label={I18n.t('publisher.action.remove')} onClick={onRemove}>
      <CloseMiniIcon color={colorIconSecondary} />
    </CloseButton>
  </Container>;

require("./controls.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./controls.js");